import { useCallback, useContext, useMemo } from 'react'
import { getConfigContext } from '../configContext'

export const useRemoteConfig = () => {
    const configContext = useMemo(() => getConfigContext(), [])
    const {
        config: { booleans, jsons, numbers, strings },
        loading,
    } = useContext(configContext)
    const configValues = useMemo(() => ({ ...strings, ...jsons, ...numbers }), [jsons, numbers, strings])

    const isFeatureEnabled = useCallback((feature: keyof typeof booleans) => booleans[feature], [booleans])

    const getConfigByName = useCallback((name: keyof typeof configValues) => configValues[name], [configValues])

    return { loading, isFeatureEnabled, getConfigByName }
}
